import { LazyLoad } from 'app/utils';

export const CompanyActivityFormPage = LazyLoad(
  () => import('./index'),
  (module) => module.CompanyActivityFormPage,
);
